/**
 *
 * FormField
 *
 */

import React from 'react';
import styled from 'styled-components';
import './style.scss';

//empty decoration causes layout issue
const renderDecoration = function(d) {
  if (!d) return '';
  if (d === true) return '\u00A0';
  return d;
};

export function Input(props) {
  let leftDecoration = props.leftDecoration ? (
    <LeftDecoration>{renderDecoration(props.leftDecoration)}</LeftDecoration>
  ) : null;
  let rightDecoration = props.rightDecoration ? <RightDecoration>{props.rightDecoration}</RightDecoration> : null;

  let inputProps = { ...props };

  inputProps.onKeyDown = props.onEnter
    ? function(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          props.onEnter();
        }
      }
    : null;

  let full = inputProps.full;
  try {
    delete inputProps.leftDecoration;
    delete inputProps.rightDecoration;
    delete inputProps.small;
    delete inputProps.right;
    delete inputProps.medium;
    delete inputProps.onEnter;
    delete inputProps.full;
  } catch (e) {}

  let classes = ['input-element'];

  if (leftDecoration) classes.push('decorated', 'decorated-left');
  if (rightDecoration) classes.push('decorated', 'decorated-right');

  if (props.right) classes.push('right');
  if (props.small) classes.push('small');
  if (props.medium) classes.push('medium');
  if (props.large) classes.push('large');

  if (props.strongValue) classes.push('strongValue');
  if (props.capitalizedValue) classes.push('capitalizedValue');

  let styleDiv = props.mediumWide && { width: '100%' };

  if (props.style) {
    styleDiv = {
      ...styleDiv,
      ...props.style,
    };
  }

  return (
    <div className={`${leftDecoration || rightDecoration ? 'decorated' : ''} ${!!full && 'full'}`} style={styleDiv}>
      {leftDecoration}
      {props.type === 'textarea' ? (
        <textarea className={classes.join(' ')} {...inputProps} cols={50} style={{ resize: 'none' }}>
          {props.children}
        </textarea>
      ) : (
        <input className={classes.join(' ')} {...inputProps} style={props.mediumwide && { width: '100%' }}>
          {props.children}
        </input>
      )}
      {rightDecoration}
    </div>
  );
}

export function LeftDecoration(props) {
  return <span className="decoration left">{props.children}</span>;
}

export function RightDecoration(props) {
  return <span className="decoration right">{props.children}</span>;
}

export function FormControl(props) {
  return (
    <div className={`form-controlField ${props.label ? 'labeled' : ''}`}>
      {props.label ? <FormControlLabel>{props.label}</FormControlLabel> : null}
      {props.children}
    </div>
  );
}

export const DecoratorLabel = styled.div`
  background-color: #ddd;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 6px;
  font-weight: 600;
`;

export const FormControlLabel = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
`;
